import { Link } from "react-router-dom";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";

import logo from "../assets/logo.svg";
import classes from "./Header.module.scss";
import { logoutAPi } from "../API/endpoints/auth";
import { sliceActions as userActions } from "../store/user-slice";
import { useEffect } from "react";
import { decodeToken } from "../utils/auth";

export default function Header() {
  const dispatch = useDispatch();

  const accessToken = useSelector((state) => state.auth.accessToken);
  const decodedToken = accessToken ? decodeToken(accessToken) : "";
  const isAdmin = decodedToken?.roles?.includes("ROLE_ADMIN");

  useEffect(() => {
    if (!accessToken) dispatch(userActions.setUser({}));
  }, [accessToken, dispatch]);

  const handleLogout = async () => {
    await logoutAPi();
  };

  return (
    <div>
      <div className={classes.header}>
        <Link to="/">
          <img src={logo} className={classes.logo} alt="LOGO" />
        </Link>
        {accessToken && !isAdmin && (
          <Button onClick={handleLogout} className={classes.logoutButton}>
            Logout
          </Button>
        )}
      </div>
    </div>
  );
}
